import { useSuspenseQuery } from '@tanstack/react-query';

import { Content } from '@/core/components';

import { ProofAction } from '@feature/proof/ProofAction';
import { ProofUploadRequest } from '@feature/proof/ProofTypes';
import { Author, Id } from '@feature/utils';

import {
  getTechnologicalTransferProofsOptions,
  useDeleteTechnologicalTransferProof,
  useUploadOrUpdateTechnologicalTransferProof,
} from './model/TechnologicalTransferProofModel';

interface TechnologicalTransferProofActionProps {
  technologicalTransferId: number;
  authors: Author[];
  variant?: 'compact';
}

export function TechnologicalTransferProofAction({
  technologicalTransferId,
  authors,
}: TechnologicalTransferProofActionProps) {
  const { data: proofs } = useSuspenseQuery(getTechnologicalTransferProofsOptions(technologicalTransferId));
  const uploadOrUpdateMutation = useUploadOrUpdateTechnologicalTransferProof(technologicalTransferId);
  const deleteMutation = useDeleteTechnologicalTransferProof(technologicalTransferId);

  const handleUpload = (request: ProofUploadRequest) => {
    uploadOrUpdateMutation.mutate(request);
  };

  const handleDelete = (proofId: Id) => {
    deleteMutation.mutate(proofId);
  };

  return (
    <Content type="full">
      <ProofAction
        proofs={proofs}
        entity="technological-transfer"
        onUpload={handleUpload}
        onDelete={handleDelete}
        isPending={uploadOrUpdateMutation.isPending || deleteMutation.isPending}
        authors={authors}
      />
    </Content>
  );
}
